import styled from 'styled-components';

// MainContainer: flex row — Sidemenu is a NORMAL FLOW element (not fixed),
// width 250px, sitting on the left. Content fills the rest.
export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  background: #f5f5f5;
`;

export const SidemenuDiv = styled.div`
  flex-shrink: 0;
  width: 250px;
`;

// No margin-left needed — Sidemenu is already in the flex flow taking 250px.
// flex:1 + min-width:0 makes this fill all remaining horizontal space.
export const ContentWrapDiv = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
  background: #f7f8fc;
`;

export const ContainerDiv = styled.div`
  max-width: 936px;
  display: flex;
  flex-direction: column;
  padding: 15px;
  color: #1E2228;
  box-sizing: border-box;
  & input, textarea {
    border: 1px solid #c9c9c9;
    border-radius: 6px;
    padding: 14px 16px;
    font-size: 16px;
  }
  & textarea { resize: none; }
  @media (max-width: 940px) { padding: 10px 40px; }
`;

export const HeaderDiv = styled.div`
  position: fixed;
  top: 0; right: 0; left: 0;
  z-index: 2000;
`;

export const BackDiv = styled.div`
  & a {
    color: #1B49EA;
    font-size: 16px;
    display: flex;
    align-items: center;
    &:before {
      content: '';
      height: 10px; width: 10px;
      border-left: 2px solid #1B49EA;
      border-bottom: 2px solid #1B49EA;
      position: relative;
      transform: rotate(45deg);
      margin-right: 12px;
    }
  }
`;

export const MainHeadingDiv = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-top: 24px;
`;

export const SubHeadingDiv = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 36px;
`;

export const Text1Div = styled.div`
  font-size: 14px;
  color: #555;
`;

export const HeadingDiv = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
  & span { color: #ff2c91; }
`;

export const Heading3Div = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 35px 0 15px 0;
  display: flex;
  align-items: center;
`;

export const Heading2Div = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
`;

export const Text2Div = styled.div`
  font-size: 14px;
  color: #939599;
  margin-top: 12px;
`;

export const Text3Div = styled.div`font-size: 12px;`;

export const ShowLessButton = styled.button`
  font-size: 16px;
  font-weight: bold;
  color: #1B49EA;
  background: none;
  border: none;
  padding: 0;
  margin: 30px 0 0 0;
  align-self: flex-start;
`;

export const RowDiv = styled.div`display: flex;`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RoleWrapDiv = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
  & label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
  }
`;

export const LocationWrapDiv = styled.div`
  display: flex;
  & label {
    margin-right: 40px;
    & input { margin-right: 10px; }
  }
  & label:last-child { margin-right: 0; }
`;

export const SearchButton = styled.button`
  background: #1B49EA;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  border: none;
  margin: 0;
  padding: 16px 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.2s;
  &:hover { background: #1639c7; }
`;

export const SliderDiv = styled.div`
  margin: 30px 0 8px 0;
  position: relative;
  z-index: 1;
  .ant-slider { margin: 20px 8px; }
  .ant-slider-dot { display: none; }
  .ant-tooltip { z-index: 999 !important; }
  .ant-slider-mark span {
    min-width: 0; font-size: 12px; color: #979797;
    transform: none !important; white-space: nowrap;
  }
  .ant-slider-mark span:last-child { right: 0% !important; left: auto !important; }
  .ant-slider-rail { height: 6px !important; background: #b8b8b8; border-radius: 90px; }
  .ant-slider-track { background: #ff2c91; border-radius: 90px; height: 6px !important; }
  .ant-slider-handle { border: none !important; background: #ff2c91; box-shadow: 0 0 8px rgba(0,0,0,0.3); }
  .ant-tooltip-inner {
    min-height: 38px !important; min-width: 38px;
    display: flex; align-items: center; justify-content: center; box-shadow: none;
  }
  .ant-tooltip-arrow {
    height: 0 !important; width: 0 !important; top: 0 !important;
    border-bottom: 26px solid #ff2c91;
    border-right: 18px solid transparent;
    border-left: 18px solid transparent;
    border-top: 0 solid transparent;
    z-index: -1;
    & span { display: none; }
  }
  &:hover .ant-slider-track { background: #ff2c91; }
`;

export const HiddenDiv = styled.div`
  display: ${props => props.show === true ? 'flex' : 'none'};
  flex-direction: column;
`;

export const AutosearchDiv = styled.div`
  width: 100%;
  .ant-select { width: 100%; margin-bottom: 0; }
  .ant-select-selector {
    height: 54px !important;
    padding: 12px 16px !important;
    border-radius: 8px !important;
    border: 1px solid #c9c9c9 !important;
    box-shadow: none !important;
    .ant-select-selection-search {
      top: 0 !important;
      bottom: 0 !important;
      right: 16px; left: 16px;
      display: flex !important;
      align-items: center !important;
      padding: 0 !important;
      .ant-select-selection-search-input {
        margin: 0 !important;
        height: 100% !important;
      }
    }
    .ant-select-selection-placeholder { color: #7e7e7e !important; }
  }
`;

export const ErrorDiv = styled.div`
  color: red; font-size: 14px; margin-top: 16px;
`;

export const MandatoryDiv = styled.div`
  color: #ff2c91; font-size: 12px; font-weight: normal; margin-top: 50px;
`;

export const SkillOptionDiv = styled.div`
  display: flex; align-items: center; justify-content: flex-end;
  & button { font-size: 14px; color: #1B49EA; border: none; background: none; margin: 0; padding: 0; }
`;

export const AddSkillButton = styled.button`
  height: 54px; width: 54px; border: none; background-color: #ffffff;
  flex-shrink: 0; margin-left: 12px; display: flex; align-items: center; justify-content: center;
  & img { width: 30px; height: 30px; display: block; }
`;

export const RemoveSkillButton = styled.button`
  height: 54px; width: 54px; border: none; background-color: #ffffff;
  flex-shrink: 0; border-radius: 6px; margin-left: 12px;
  display: flex; align-items: center; justify-content: center;
  & img { width: 30px; height: 30px; display: block; }
`;

export const ResetFilterButton = styled.button`
  color: #ff2c91; font-size: 12px; margin: 0 0 0 12px; padding: 3px 8px; border: none; border-radius: 4px;
`;

export const NotAvailableDiv = styled.div`
  display: flex; padding: 17px; background-color: #FFEBD2; border-radius: 8px; align-items: flex-start;
  & img { width: 20px; flex-shrink: 0; margin-top: 4px; }
  & > div {
    display: flex; flex-direction: column; font-size: 12px; color: #1E2228; margin-left: 13px;
    & div:first-child { font-weight: bold; }
  }
`;